import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Settings from "../components/Settings"

const SettingsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <Settings />
        </div>
      </main>
    )
}

export default SettingsPage